module.exports = __webpack_public_path__ + "img/icon.629e7e05.svg";